import { useGetMySummary } from "@/api/user/useGetMySummary";
import { useAuth } from "@/auth/AuthContext";
import { isViewingAs } from "@/auth/viewAs";
import { Crisp } from "crisp-sdk-web";
import { useEffect, useRef } from "react";

export function useCrisp() {
  const { user } = useAuth();
  const { data: userSummary } = useGetMySummary();
  const hasShownWelcomeMessage = useRef(false);

  useEffect(() => {
    if (!import.meta.env.VITE_CRISP_WEBSITE_ID) {
      return;
    }

    // Hide chat by default when component mounts
    Crisp.chat.hide();

    // Re-hide widget when user closes the chat
    const handleChatClosed = () => {
      Crisp.chat.hide();
    };

    Crisp.chat.onChatClosed(handleChatClosed);

    return () => {
      Crisp.chat.offChatClosed();
    };
  }, []);

  const openChatWithUserData = () => {
    if (!import.meta.env.VITE_CRISP_WEBSITE_ID) {
      console.warn("Crisp Website ID not configured");
      return;
    }

    // Set user data if available. In view-as mode the summary belongs to another user.
    if (userSummary && !isViewingAs()) {
      if (userSummary.email) {
        Crisp.user.setEmail(userSummary.email);
      }
      if (userSummary.name) {
        Crisp.user.setNickname(userSummary.name);
      }
      if (userSummary.phoneNumber) {
        Crisp.user.setPhone(userSummary.phoneNumber);
      }

      // Set custom session data
      Crisp.session.setData({
        user_id: user?.id || "unknown",
        signup_date: userSummary.createdAt || "unknown",
      });
    }

    // Load Crisp (if not already loaded), show the widget, and open the chat
    Crisp.chat.show();
    Crisp.chat.open();

    // Show welcome message only once per session
    if (!hasShownWelcomeMessage.current) {
      Crisp.message.showText(
        "안녕하세요! OFF 고객센터입니다.\n\n" +
          "저희 디너는 매주 수요일 저녁에 진행됩니다.\n" +
          "고객센터 운영시간: 평일 오전 9시 - 오후 5시 (한국시간)\n\n" +
          "무엇을 도와드릴까요?"
      );
      hasShownWelcomeMessage.current = true;
    }
  };

  return { openChatWithUserData };
}
